export default "__VITE_ASSET__ki_Y$2ur__"